export default {
  'step1': '邮件验证',
  'step2': '事先确认',
  'step3': '法人信息',
  'step4': 'E-KYC',
  'step5': '店铺信息',
  'step6': '支付相关信息',
  'step7': '文件上传',
  'new': '加盟申请'
}
